export type TagTypeEnum = 'STEP' | 'SESSION' | 'USER' | 'DOCUMENT';
export const TagTypeEnum = {
  STEP: 'STEP' as TagTypeEnum,
  SESSION: 'SESSION' as TagTypeEnum,
  USER: 'USER' as TagTypeEnum,
  DOCUMENT: 'DOCUMENT' as TagTypeEnum
};
